import React, { useState, useEffect, lazy, Suspense } from 'react';
import './App.css';
import './styles/Navbar.css';
import './styles/Darktheme.css';
import './styles/LoginNavbar.css';
import './styles/Dashboard.css';
import './styles/CustomPieChart.css';
import './styles/MetricCard.css';
import './styles/RankingTable.css';
import './styles/Login.css';
import './styles/UserManagement.module.css';
import './styles/Modal.css';
import './styles/FileUpload.css';
import './styles/BotaoUpload.css';
import './styles/FormElementosDeDespesas.css';
import './styles/BotaoBaixarSuprimentoPDF.css';
import './styles/ModalDetalhesInfo.css';
import './styles/Diaria.css';
import './styles/EditField.css';
import './styles/Confirmation.css';
import './styles/Form.css';
import './styles/GerenciamentoFerias.css';
import './styles/CadastroFrequencia.css';
import './styles/RH.css';
import './styles/Solicitacao.css';
import './styles/Homepage.css';
import './styles/PedidoDiaria.css';
import 'react-datepicker/dist/react-datepicker.css';
import './styles/Autorizacaocolaboradormodal.css';
import './styles/PedidoSuprimento.css';
import './styles/PedidoDiariaEventual.css';
import './styles/SolicitacaoDiaria.css';
import './processos/styles/Dashboard.module.css';
import './processos/styles/TramitacoesStepper.module.css';
import './processos/styles/ProcessDetailsModal.css';
import './processos/styles/ProcessForm.css';
import './processos/styles/ProcessList.css';
import './processos/styles/app.css';
import './processos/styles/contratos.css';
import Navbar from './components/Navbar';
import LoginNavbar from './components/LoginNavbar';
import { BrowserRouter, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import ReconnectingWebSocket from 'reconnecting-websocket';
import { receiveUpdateD, receiveUpdateS } from './utils/dataManager.js';
import { clearAuthSession, getToken, persistUserSession, getStoredUser } from './utils/auth';
import { useTokenWatcher } from './utils/useTokenWatcher.js';
import { AuthProvider as ProcessosAuthProvider } from './processos/services/AuthProvider';

const Dashboard = lazy(() => import('./pages/Dashboard.jsx'));
const Login = lazy(() => import('./pages/Login.jsx'));
const UserManagement = lazy(() => import('./pages/Gerenciador.jsx'));
const Cadastro = lazy(() => import('./pages/Cadastro.jsx'));
const TrocaSenha = lazy(() => import('./pages/Trocasenha.jsx'));
const Consulta = lazy(() => import('./pages/Consulta.jsx'));
const Diaria = lazy(() => import('./pages/Diaria'));
const Suprimento = lazy(() => import('./pages/Suprimento'));
const Form = lazy(() => import('./pages/Form.jsx'));
const RH = lazy(() => import('./pages/RH.jsx'));
const RHConsulta = lazy(() => import('./pages/RHConsulta.jsx'));
const Homepage = lazy(() => import('./pages/Homepage.jsx'));
const Formulario = lazy(() => import('./pages/PedidoDiaria.jsx'));
const SuprimentoFundos = lazy(() => import('./pages/SuprimentoFundos.jsx'));
const CadastroFrequencia = lazy(() => import('./pages/CadastroFrequencia.jsx'));
const FormularioSuprimento = lazy(() => import('./pages/PedidoSuprimento.jsx'));
const Solicitacao = lazy(() => import('./pages/Solicitacao.jsx'));
const PainelGerente = lazy(() => import('./pages/PainelGerente.jsx'));
const FormularioEventual = lazy(() => import('./pages/pedidoDiariaEventual.jsx'));
const FormularioConvenio = lazy(() => import('./pages/PedidoDiariaConvenio.jsx'));
const SolicitacaoDiaria = lazy(() => import('./pages/SolicitacaoDiaria.jsx').then((m) => ({ default: m.SolicitacaoDiaria })));
const PedidoPassagem = lazy(() => import('./pages/PedidoPassagem.jsx'));
const ProcessosApp = lazy(() => import('./processos/App'));

const ROTAS_SEM_LOGIN_NAVBAR = ['/user/login'];

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(() => !!getToken());
  const [isToggled, setIsToggled] = useState(() => {
    try {
      return localStorage.getItem('theme') === 'dark';
    } catch {
      return false;
    }
  });
  const [currentUser, setCurrentUser] = useState(() => (getToken() ? getStoredUser() : null));

  // WebSocket com controle de recarga retida
  useEffect(() => {
    let socket;
    if (isLoggedIn) {
      const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
      socket = new ReconnectingWebSocket(`${protocol}//${window.location.host}/websocket/`);
      socket.onmessage = (event) => {
        try {
          const message = JSON.parse(event.data);
          if (message.channel === 'updates' && message.data?.message === 'Diarias atualizadas!') {
            receiveUpdateD();
          } else if (message.channel === 'updates' && message.data?.message === 'Suprimentos atualizados!') {
            receiveUpdateS();
          } else if (message.channel === 'sistema' && message.data?.tipo === 'reload_forcado') {
            if (window.isFormActive) {
              localStorage.setItem('pendingReload', 'true');
            } else {
              window.location.reload(true);
            }
          }
        } catch (e) {
          console.log('Erro ao analisar a mensagem com JSON', e);
        }
      };
    }
    return () => { if (socket) socket.close(); };
  }, [isLoggedIn]);

  // Monitoramento Global de Elementos de Formulário e Visibilidade da Aba
  useEffect(() => {
    const verificarFocoAtivo = () => {
      const elementoAtivo = document.activeElement;
      const tagsDeEscrita = ['INPUT', 'TEXTAREA', 'SELECT'];
      
      if (elementoAtivo && tagsDeEscrita.includes(elementoAtivo.tagName)) {
        window.isFormActive = true;
      } else {
        window.isFormActive = false;
      }
    };
    const handleInputGlobal = (e) => {
      const tagsDeEscrita = ['INPUT', 'TEXTAREA', 'SELECT'];
      if (e.target && tagsDeEscrita.includes(e.target.tagName)) {
        window.isFormActive = true;
      }
    };
    const handleVisibilityChange = () => {
      if (document.hidden && localStorage.getItem('pendingReload') === 'true') {
        localStorage.removeItem('pendingReload');
        window.location.reload(true);
      }
    };
    document.addEventListener('focusin', verificarFocoAtivo);
    document.addEventListener('focusout', () => {
      setTimeout(verificarFocoAtivo, 100);
    });
    document.addEventListener('input', handleInputGlobal);
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('focusin', verificarFocoAtivo);
      document.removeEventListener('focusout', verificarFocoAtivo);
      document.removeEventListener('input', handleInputGlobal);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  // Intercepta o Global do Fetch para efetuar o recarregamento pós-submit
  useEffect(() => {
    const originalFetch = window.fetch;
    window.fetch = async (...args) => {
      const response = await originalFetch(...args);
      
      if (response.ok && localStorage.getItem('pendingReload') === 'true') {
        const url = args[0];
        const opcoes = args[1] || {};
        const metodo = (opcoes.method || 'GET').toUpperCase();
        const metodosDeEscrita = ['POST', 'PUT', 'DELETE', 'PATCH'];
        const ehRequisicaoDeSalvamento = metodosDeEscrita.includes(metodo);
        const ehChamadaDeValidacao = typeof url === 'string' && (url.includes('/api/setores') || url.includes('/api/cargos'));
        if (ehRequisicaoDeSalvamento && !ehChamadaDeValidacao) {
          localStorage.removeItem('pendingReload');
          setTimeout(() => {
            window.location.reload(true);
          }, 800); // Aguarda 800ms para que mensagens de sucesso visuais apareçam antes do reload
        }
      }
      
      return response;
    };
    return () => {
      window.fetch = originalFetch;
    };
  }, []);

  // Setup inicial
  useEffect(() => {
    document.body.classList.toggle('dark-theme', isToggled);
  }, [isToggled]);

  const handleLogin = (tokenValue, userData) => {
    const user = userData ? {
      id:         userData.id          || '',
      id_setor:   userData.id_setor    || '',
      nome:       userData.name        || userData.nome      || '',
      username:   userData.username    || '',
      perfil:     userData.role        || userData.perfil    || '',
      setor:      userData.setor       || '',
      permissoes: userData.permissoes  || [],
    } : {
      id: '', id_setor: '', nome: '', username: '', perfil: '', setor: '', permissoes: [],
    };
    persistUserSession(tokenValue, user);
    setCurrentUser(user);
    
    // atualiza estado React imediatamente
    setIsLoggedIn(true);
  };

  const handleLogout = () => {
    clearAuthSession();
    setIsLoggedIn(false);
    setCurrentUser(null);
  };

  const handleToggle = () => {
    const next = !isToggled;
    setIsToggled(next);
    document.body.classList.toggle('dark-theme', next);
    localStorage.setItem('theme', next ? 'dark' : 'light');
  };

  useTokenWatcher(handleLogout);


  return (
    <BrowserRouter>
      <Suspense fallback={<div className="page-loading" />}>
      <Routes>
        <Route path="/processos/*" element={<ProcessosAuthProvider><ProcessosApp /></ProcessosAuthProvider>} />
        <Route path="/contratos/*" element={<ProcessosAuthProvider><ProcessosApp /></ProcessosAuthProvider>} />
        <Route
          path="*"
          element={
            isLoggedIn ? (
              <PrivateRoutes
                onLogout={handleLogout}
                isToggled={isToggled}
                handleToggle={handleToggle}
                perfil={currentUser?.perfil}
              />
            ) : (
              <PublicRoutes onLogin={handleLogin} />
            )
          }
        />
      </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

function PrivateRoutes({ onLogout, isToggled, handleToggle, perfil }) {
  const normalizedPerfil = (perfil || '').toUpperCase().trim();
  const location = useLocation();

  const isProcessosOnly = 
    normalizedPerfil === 'EDITOR_PROCESSOS' || 
    normalizedPerfil === 'GERENTE_SETORIAL';

  if (isProcessosOnly && location.pathname !== '/user/gerente') {
    return <Navigate to="/processos" replace />;
  }

  return (
    <>
      <Navbar onLogout={onLogout} isToggled={isToggled} handleToggle={handleToggle} />
      <Suspense fallback={<div className="page-loading" />}>
      <Routes>
        <Route path="/" element={<Navigate to="/user/dashboard" replace />} />
        <Route path="/user/dashboard" element={<Dashboard onLogout={onLogout} />} />
        <Route path="/user/diaria" element={<Diaria onLogout={onLogout} />} />
        <Route path="/user/suprimento" element={<Suprimento onLogout={onLogout} />} />
        <Route path="/user/form" element={<Form onLogout={onLogout} />} />
        <Route path="/user/cadastro" element={<Cadastro onLogout={onLogout} />} />
        <Route path="/user/troca-senha" element={<TrocaSenha onLogout={onLogout} />} />
        <Route path="/user/gerenciador" element={<UserManagement onLogout={onLogout} />} />
        <Route path="/user/gerente" element={<PainelGerente />} />
        <Route path="/user/rh" element={<RH />} />
        <Route path="/user/cadastro-Frequência" element={<CadastroFrequencia />} />
      </Routes>
      </Suspense>
    </>
  );
}

function PublicRoutes({ onLogin }) {
  const location = useLocation();
  const mostrarLoginNavbar = !ROTAS_SEM_LOGIN_NAVBAR.includes(location.pathname);

  return (
    <>
      {mostrarLoginNavbar && <LoginNavbar />}
      <Suspense fallback={<div className="page-loading" />}>
      <Routes>
        <Route path="/user/login" element={<Login onLogin={onLogin} />} />
        <Route path="/consulta" element={<Consulta />} />
        <Route path="/pedido-de-diaria" element={<Formulario />} />
        <Route path="/pedido-de-diaria-eventual" element={<FormularioEventual />} />
        <Route path="/pedido-de-diaria-convenio" element={<FormularioConvenio />} />
        <Route path="/pedido-de-suprimento" element={<FormularioSuprimento />} />
        <Route path="/pedido-de-passagem" element={<PedidoPassagem />} />
        <Route path="/suprimento-de-fundos" element={<SuprimentoFundos />} />
        <Route path="/consulta-frequencia" element={<RHConsulta />} />
        <Route path="/solicitacoes" element={<Solicitacao />} />
        <Route path="/solicitacao-Diaria" element={<SolicitacaoDiaria />} />
        <Route path="/" element={<Homepage />} />
      </Routes>
      </Suspense>
    </>
  );
}

export default App;